// Constant Data for Cms::BlogPost

export const ACTIVE_STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}

export const CATEGORY = {
  FASHION               : 'fashion',
  LIFESTYLE             : 'lifestyle',
  SUSTAINABLE_LIFESTYLE : 'sustainable lifestyle',
  BEAUTY                : 'beauty',
  BABE_ON_THE_SPOT      : 'babe on the spot',
  EVENT                 : 'event',
  LOCAL_HEROES          : 'local heroes'
}

export const DESCRIPTION = {
  URL      : 'Url of Blog Post can be automatically generated using Title',
  CATEGORY : 'Blog Post can have more than 1 Category (Max 2)',
  SUMMARY  : 'Summary Blog Post will be shown in Blog Post List page https://www.tinkerlust.com/blog',
  SECTION  : 'Section(s) of Blog Post at least have description, other fields are optional',
  METADATA : 'Metadata of Blog Post fields are optional, it will be used for SEO purpose'
}